module.exports = __webpack_public_path__ + "static/img/gqlogo.c70868e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gqlogo.png
// module id = 4kch
// module chunks = 11